// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `tr:hover {
  background-color: #330aea;
  color: white;
}

td, th {
  border: 1px solid #ddd;
  padding: 8px;
  font-size: 10px;
}

.panel {
  border: 1px solid #ddd;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #f5f7fa, #DBDCDD);
}

.resets {
  display: flex;
  margin-top: 10x; /* Align items vertically center */
}

/* Buttons */
.btn-primary {
  background: #0B2D71;
  color: #fff;
  border: none;
  border-radius: 0;
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif";
  font-size: 0.88em;
  cursor: pointer;
}

.btn-primary:hover {
  background: #0066B2;
}

:host ::ng-deep .custom-save-button {
  all: unset; /* Reset all PrimeNG styles */
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #0066B2 !important; /* Primary blue background */
  color: #fff !important; /* White text */
  border: none !important; /* No border */
  padding: 6px 12px !important; /* Match padding to the text box */
  font-family: "GothamBold", "Helvetica Neue", "Helvetica", "Arial", "sans-serif" !important; /* Font family */
  font-size: 14px !important; /* Font size */
  cursor: pointer !important; /* Pointer cursor */
  transition: background 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */
}

:host ::ng-deep .custom-save-button:hover {
  background: #0B2D71 !important; /* Darker blue on hover */
  color: #fff !important; /* Ensure white text on hover */
}

:host ::ng-deep .custom-save-button:disabled {
  background: #d6d8db !important; /* Gray background for disabled state */
  color: #6c757d !important; /* Muted text color */
  cursor: not-allowed !important; /* Disabled cursor */
  box-shadow: none !important; /* Remove shadow for disabled state */
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/project-info-report/project-info-report.component.scss"],"names":[],"mappings":"AAAA;EACI,yBAAA;EACA,YAAA;AACJ;;AACG;EACC,sBAAA;EACA,YAAA;EACA,eAAA;AAEJ;;AACE;EACE,sBAAA;EACA,mBAAA;EACA,aAAA;EACA,yCAAA;EACA,qDAAA;AAEJ;;AACE;EAAU,aAAA;EAAe,eAAA,EAAA,kCAAA;AAI3B;;AAHC,YAAA;AACD;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAEA,+EAAA;EACA,iBAAA;EACA,eAAA;AAKF;;AADA;EACE,mBAAA;AAIF;;AAEE;EACA,UAAA,EAAA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA,EAAA,4BAAA;EACA,sBAAA,EAAA,eAAA;EACA,uBAAA,EAAA,cAAA;EACA,4BAAA,EAAA,kCAAA;EACA,0FAAA,EAAA,gBAAA;EACA,0BAAA,EAAA,cAAA;EACA,0BAAA,EAAA,mBAAA;EACA,gEAAA,EAAA,uCAAA;AACF;;AAEA;EACE,8BAAA,EAAA,yBAAA;EACA,sBAAA,EAAA,+BAAA;AACF;;AAEA;EACE,8BAAA,EAAA,uCAAA;EACA,yBAAA,EAAA,qBAAA;EACA,8BAAA,EAAA,oBAAA;EACA,2BAAA,EAAA,qCAAA;AACF","sourcesContent":["tr:hover {\n    background-color: #330aea;\n    color: white;\n  }\n   td,  th {\n    border: 1px solid #ddd;\n    padding: 8px;\n    font-size: 10px;\n  }\n  \n  .panel {\n    border: 1px solid #ddd;\n    border-radius: 12px;\n    padding: 20px;\n    box-shadow: 0 6px 12px rgba(0,0,0,0.1);\n    background: linear-gradient(135deg, #f5f7fa, #DBDCDD);\n  }\n\n  .resets { display: flex; margin-top: 10x; /* Align items vertically center */ }\n /* Buttons */\n.btn-primary {\n  background:#0B2D71 ;\n  color: #fff;\n  border: none;\n  border-radius: 0;\n \n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif';\n  font-size: 0.88em;\n  cursor: pointer;\n // transition: background 0.3s, transform 0.3s;\n}\n\n.btn-primary:hover {\n  background:  #0066B2;\n // transform: translateY(-2px); /* Lift effect on hover */\n}\n  // .btn-primary:active {\n  //   box-shadow: 0 2px #0056b3, 0 0 15px 3px rgba(0, 123, 255, 0.7);\n  // }\n  :host ::ng-deep .custom-save-button {\n  all: unset; /* Reset all PrimeNG styles */\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #0066B2 !important; /* Primary blue background */\n  color: #fff !important; /* White text */\n  border: none !important; /* No border */\n  padding: 6px 12px !important; /* Match padding to the text box */\n  font-family: 'GothamBold', 'Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif' !important; /* Font family */\n  font-size: 14px !important; /* Font size */\n  cursor: pointer !important; /* Pointer cursor */\n  transition: background 0.3s ease, transform 0.2s ease !important; /* Smooth hover and transform effects */\n}\n\n:host ::ng-deep .custom-save-button:hover {\n  background: #0B2D71 !important; /* Darker blue on hover */\n  color: #fff !important; /* Ensure white text on hover */\n}\n\n:host ::ng-deep .custom-save-button:disabled {\n  background: #d6d8db !important; /* Gray background for disabled state */\n  color: #6c757d !important; /* Muted text color */\n  cursor: not-allowed !important; /* Disabled cursor */\n  box-shadow: none !important; /* Remove shadow for disabled state */\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
